import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AccountStatus, AccountsStatusCounts } from '../accounts-overview/accounts-overview.types';
import { StatusPieLayer, statusPieLayers } from './status-pie';

/**
 * How far a balance-sheet position is: a small pie of its accounts by status, in the light tones of
 * the status badges, with the counts in the tooltip. The Konten table and the Jahresabschluss overview
 * show the same pie, so a position reads the same on both.
 */
@Component({
    selector: 'abcp-status-pie',
    templateUrl: './status-pie.component.html',
    styleUrls: ['./status-pie.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbcpStatusPieComponent {
    @Input() counts: AccountsStatusCounts = { reconciled: 0, difference: 0, open: 0 };

    /** The worst status decides: one difference makes the position red, one open account grey. */
    @HostBinding('attr.data-status')
    get status(): AccountStatus {
        if (this.counts.difference > 0) {
            return 'difference';
        }

        return this.counts.open > 0 ? 'open' : 'reconciled';
    }

    get layers(): StatusPieLayer[] {
        return statusPieLayers(this.counts);
    }
}
